import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const setlogDefect = async (params) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const { companyid } = JSON.parse(userDetails);

  const { productId, tcid, tcrid, status, projectKey, tcname, message, issueType } = params;
  if (!productId || !tcid || !tcrid || !status || !projectKey || !tcname || !issueType) {
    throw new Error("Missing required parameters for logging defect");
  }
  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=logDefect&productId=${productId}&tcid=${tcid}&tcrid=${tcrid}&status=${status}&projectKey=${projectKey}&tcname=${tcname}&message=${message}&cid=${companyid}&issueType=${issueType}`,
  );
  return response.data;
};

const useSetLogDefect = (options = {}) => {
  return useMutation({
    mutationFn: setlogDefect,
    ...options,
  });
};

export default useSetLogDefect;
